import fetch from 'isomorphic-fetch'
import { RSAA } from 'redux-api-middleware'
import { Env, getEnv } from '@cinch/oxd-utils/env/src'

import {
  REQUEST_FINANCE_QUOTES,
  RECEIVE_FINANCE_QUOTES,
  ERROR_FINANCE_QUOTES,
  RECEIVE_FINANCE_DECISION,
  REQUEST_INDICATIVE_APR,
  RECEIVE_INDICATIVE_APR,
  ERROR_INDICATIVE_APR,
  REQUEST_DEPOSIT_RANGE,
  RECEIVE_DEPOSIT_RANGE,
  ERROR_DEPOSIT_RANGE,
} from './constants'

const FINANCE_SERVICE_URL = getEnv(Env.FinanceServiceUrl)

export type FindQuotesRequest = {
  annualMiles: string
  deposit: string
  orderId: string
  vehicleId: string
  term: string
}

export const getFinanceDecision = (decision: string) => ({ type: RECEIVE_FINANCE_DECISION, payload: decision })

export const getFinanceQuotes = (body: FindQuotesRequest) => {
  return {
    [RSAA]: {
      endpoint: `${FINANCE_SERVICE_URL}/finance/quote`,
      method: 'POST',
      body: JSON.stringify(body),
      fetch,
      types: [REQUEST_FINANCE_QUOTES, RECEIVE_FINANCE_QUOTES, ERROR_FINANCE_QUOTES],
    },
  }
}

export const getIndicativeAprRate = () => {
  return {
    [RSAA]: {
      endpoint: `${FINANCE_SERVICE_URL}/finance/indicative-rate`,
      method: 'GET',
      fetch,
      types: [REQUEST_INDICATIVE_APR, RECEIVE_INDICATIVE_APR, ERROR_INDICATIVE_APR],
    },
  }
}

export const getDepositRange = (amountPayableInPence: number) => {
  return {
    [RSAA]: {
      endpoint: `${FINANCE_SERVICE_URL}/finance/deposit-range?amountOutstanding=${amountPayableInPence}`,
      method: 'GET',
      fetch,
      types: [REQUEST_DEPOSIT_RANGE, RECEIVE_DEPOSIT_RANGE, ERROR_DEPOSIT_RANGE],
    },
  }
}
